<script>
export default {
  
}
</script>

<template>
  <nav class="p-0 navbar navbar-expand-lg navbar-dark bg-primary">
    <div class="container px-3">
      <a href="/">
        <h2 class="navbar-brand text-white">Katherine Watts Martinez Photography</h2>
      </a>
      <button
        class="navbar-toggler navbar-toggler-right"
        type="button"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
        >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto py-3 pl-1">
          <li class="nav-item py-2">
            <router-link class="nav-link text-light text-decoration-none" :to="{ name: 'about' }">About</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
